import Component from '../../../shared/component';

export default class AvatarBuilderOption extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);
    this.category = this.$element.data('category');
    this.required = this.$element.data('required');
    this.locked = this.$element.data('locked');
    this.enabled = false;

    this.avatarBuilder = opts.avatarBuilder;
    this.itemType = opts.itemType;

    this.id = this.$element.data(`${this.itemType.toLowerCase()}-id`);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.AvatarBuilderOption', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.AvatarBuilderOption', this.handleClick);
  }

  handleClick() {
    if (!this.enabled) return;

    this.avatarBuilder.handleItemSelection(
      this.id,
      this.category,
      this.itemType,
      this.required
    );
  }

  markAsSelected() {
    this.$element.addClass('selected');
  }

  markAsUnselected() {
    this.$element.removeClass('selected');
  }

  markAsEnabled() {
    if (this.locked) return;

    this.enabled = true;
    this.$element.removeClass('disabled');
  }

  markAsDisabled() {
    this.enabled = false;
    this.$element.addClass('disabled');
  }
}
